import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import subscriptionSelector from '../redux/selectors/subscriptionSelector'
import { Crisp as CrispSdk } from 'crisp-sdk-web'
import { CRISP_WEBSITE_ID } from '../utils/consts'

export const Crisp = () => {
  const subscription = useSelector(subscriptionSelector)
  const subscriber = subscription?.subscriber

  const [isTriggered, setIsTriggered] = useState(false)

  useEffect(() => {
    if (!subscriber) {
      return
    }

    CrispSdk.configure(CRISP_WEBSITE_ID, {
      locale: 'fr-fr',
    })

    if (subscriber.email) {
      CrispSdk.user.setEmail(subscriber.email)
    }

    if (subscriber.firstName || subscriber.lastName) {
      CrispSdk.user.setNickname(`${subscriber.firstName} ${subscriber.lastName}`.trim())
    }

    if (subscriber.phone) {
      CrispSdk.user.setPhone(subscriber.phone)
    }

    CrispSdk.chat.onChatOpened(() => {
      if (isTriggered) {
        // Prevent starting the scenario twice
        return
      }

      CrispSdk.session.pushEvent('scenario_mybooster_help')
      setIsTriggered(true)
    })
  }, [isTriggered, subscriber])

  return null
}
